<template>
    <header class="border-gray-300 shadow-md sticky top-0 z-40 bg-white">
        <div class="container mx-auto relative flex items-stretch justify-between">
            <div class="px-2 w-full flex">
                <div class="flex flex-nowrap items-center justify-between py-3 flex-grow">
                    <div class="flex items-center flex-grow">
                        <a href="https://www.bdew.de/" target="_blank">
                            <img src="/img/bdew_logo.svg" alt="BDEW" title="BDEW"/>
                        </a>
                        <div class="flex items-center justify-between flex-grow">
                            <router-link to="/" class="ml-2 sm:ml-8 inline-block whitespace-nowrap tracking-wide font-bold mr-2 text-xs md:text-base">Online-Heizkostenvergleich <span class="text-gray-300 text-sm lining-nums tabular-nums">(v{{ appVersion }})</span></router-link>
                            <div class="hidden xl:flex items-center mr-8 text-sm">
                                <Icon name="support" class="mr-2 inline-block" :height="5" :width="5" /> Haben Sie Fragen? <router-link to="/contact" class="font-bold underline inline-block ml-2 text-gray-300">Nehmen Sie Kontakt auf</router-link>
                            </div>
                        </div>

                    </div>
                    <template v-if="!loggedIn">
                        <div class="hidden lg:flex items-center">
                            <base-button :router-link="true" link="login" button-class="invert">Anmelden</base-button>
                            <base-button :router-link="true" link="register" class="ml-0 md:ml-6">Registrieren
                            </base-button>
                        </div>
                    </template>
                </div>
                <template v-if="loggedIn">
                    <router-link to="/account" class="bg-gray-100 hover:bg-gray-200 text-text-default px-3 hidden sm:flex flex-col items-center justify-center cursor-pointer transition-colors ease-in-out duration-500">
                        <Icon name="account"/>
                        <span class="text-sm">Account</span>
                    </router-link>

                    <div @click="onLogout" class="bg-gray-100 hover:bg-gray-200 text-text-default px-3 hidden sm:flex flex-col items-center justify-center cursor-pointer transition-colors ease-in-out duration-500">
                        <Icon name="logout"/>
                        <span class="text-sm ">Logout</span>
                    </div>
                </template>

                <template v-else>
                    <router-link to="login" class="bg-gray-100 hover:bg-gray-200 text-text-default px-3 hidden sm:flex lg:hidden flex-col items-center justify-center cursor-pointer transition-colors ease-in-out duration-500">
                        <Icon name="login"/>
                        <span class="text-sm">Anmelden</span>
                    </router-link>
                    <router-link to="register" class="bg-gray-100 hover:bg-gray-200 text-text-default px-3 hidden sm:flex lg:hidden flex-col items-center justify-center cursor-pointer transition-colors ease-in-out duration-500">
                        <Icon name="register"/>
                        <span class="text-sm">Registrieren</span>
                    </router-link>
                </template>

                <div @click="openMenu = !openMenu" class="bg-gray-100 hover:bg-gray-200 text-text-default px-3 flex sm:hidden flex-col items-center justify-center cursor-pointer transition-colors ease-in-out duration-500">
                    <Icon :name="openMenu ? 'close' : 'menu'"/>
                    <span class="text-sm pointer-events-none">Menü</span>
                </div>
            </div>
        </div>
        <div class="absolute h-0 w-full bottom-0">
            <div class="container relative mx-auto">
                <div id="messages" class="absolute z-40 top-4 right-2"></div>
            </div>
        </div>
        <div id="mobile-menu" v-if="openMenu" class="block sm:hidden">

            <template v-if="loggedIn">
                <div @click="onClickMobileNav('account')"  class="bg-gray-100 hover:bg-gray-200 text-text-default px-3 py-4 flex flex-row items-center justify-start cursor-pointer transition-colors ease-in-out duration-500">
                    <Icon name="account"/>
                    <span class="text-sm ml-2">Account</span>
                </div>

                <div @click="onLogout()"  class="bg-gray-100 hover:bg-gray-200 text-text-default px-3 py-4 flex flex-row items-center justify-start cursor-pointer transition-colors ease-in-out duration-500">
                    <Icon name="logout"/>
                    <span class="text-sm ml-2">Logout</span>
                </div>
            </template>
            <template v-else>
                <div @click="onClickMobileNav('login')" class="bg-gray-100 hover:bg-gray-200 text-text-default px-3 py-4 flex flex-row items-center justify-start cursor-pointer transition-colors ease-in-out duration-500">
                    <Icon name="login"/>
                    <span class="text-sm ml-2">Anmelden</span>
                </div>
                <div @click="onClickMobileNav('register')"  class="bg-gray-100 hover:bg-gray-200 text-text-default px-3 py-4 flex flex-row items-center justify-start cursor-pointer transition-colors ease-in-out duration-500">
                    <Icon name="register"/>
                    <span class="text-sm ml-2">Registrieren</span>
                </div>
            </template>
        </div>
    </header>

</template>

<script>
import {computed, getCurrentInstance, ref} from "vue";
import {useStore} from "vuex";
import {useRouter,} from 'vue-router';
import {API} from "@/utils/api";
import Icon from "./Icon";

export default {
    setup() {
        const store = useStore();
        const router = useRouter();
        const loggedIn = computed(() => store.getters['Customer/isLoggedIn']);
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;
        const openMenu = ref(false);
        const appVersion = ref(window.APP_VERSION);

        const onLogout = () => {
            openMenu.value = false

            API.post('logout', {}).then((resp) => {
                store.dispatch('Customer/logout').then(function () {

                    emitter.emit("flash-message", {
                        text: 'logged out successfully',
                        type: 'success'
                    })
                    router.push('/')
                }).catch(err => console.error(err))
            }).catch(err => {
                console.error(err)
            })
        }

        const onClickMobileNav = (route) => {
            router.push(route);
            openMenu.value = false
        }


        return {
            loggedIn,
            onLogout,
            openMenu,
            onClickMobileNav,
            appVersion
        }
    }
}
</script>
